import React, { ReactNode } from 'react'

type Props = { children: ReactNode, className?: string } & React.DetailedHTMLProps<React.HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement>
export const SignupTitle = ({ children, className, ...rest }: Props) => <h1 {...rest} className={`signup__title ${className || ''}`}>{children}</h1>
export const SignupSubTitle = ({ children, className, ...rest }: Props) => <h2 {...rest} className={`signup__sub-title ${className || ''}`}>{children}</h2>
